import { useMemo } from 'react';

import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

import { useEntityPickerData } from '../../utils/catalog';
import { PickerSelect } from '../PickerSelect';

export const ProductAreaPickerField = (
  props: FieldExtensionComponentProps<string>,
) => {
  const {
    onChange,
    schema: { title = 'Product Area', description = '' } = {},
    required,
    rawErrors,
    formContext,
    name,
  } = props;

  const selectedProductArea = (formContext?.formData?.[name] as string) || '';
  const catalogApi = useApi(catalogApiRef);

  // Memoize filter and fields to prevent infinite re-renders and API calls
  const filter = useMemo(
    () => ({ kind: ['Group'], 'spec.type': ['product-area'] }),
    [],
  );
  const fields = useMemo(
    () => [
      'kind',
      'metadata.name',
      'metadata.namespace',
      'metadata.title',
      'metadata.description',
      'spec.type',
    ],
    [],
  );

  const { value, loading } = useEntityPickerData(catalogApi, filter, fields);

  const errorText = rawErrors?.[0] as string | undefined;

  return (
    <PickerSelect
      title={title}
      description={description}
      required={required}
      value={selectedProductArea}
      onChange={onChange}
      loading={loading}
      errorText={errorText}
      options={value?.options || []}
      labelId="product-area-picker-label"
    />
  );
};
